import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgPeopleFind = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M12 1.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Zm0 2a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM11 12a1 1 0 0 1 0 2c-4.443 0-8 3.162-8 7a1 1 0 0 1-2 0c0-4.999 4.502-9 10-9ZM17.5 13.5a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z" />
      <path d="M19.2 18.9a1 1 0 0 1 1.295-.269l.105.069 2 1.5a1 1 0 0 1-1.095 1.669L21.4 21.8l-2-1.5a1 1 0 0 1-.2-1.4Z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgPeopleFind)
const Memo = memo(ForwardRef)
export default Memo
